import React, { useRef, useState, useEffect } from "react";
import clsx from "clsx";
import { useUpdateData } from "hooks/useApiHooks";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import PermissionMiddleware from "middleware/PermissionMiddleware";
import { sendBookingStatusChangedEvent } from "services/websocket/websocketUtils";

const ChangeOrderStatus = ({ initialData, refetch, onSuccess, onError }) => {
  const API_URL = "/reservation";

  const [formData, setFormData] = useState({
    status: initialData?.status || "",
  });
  const pendingStatusRef = useRef(initialData?.status || "");

  const { updateData: updateBooking } = useUpdateData(
    `${API_URL}/${initialData?.id}/status`
  );

  const { handleSuccessToast, handleError } = useCanvasHandler();

  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    updateBooking,
    async (responseData) => {
      // handleSuccessToast(true, "Status updated successfully!");
      // await refetch?.();
      onSuccess?.();
      sendBookingStatusChangedEvent(
        responseData || { ...initialData, status: pendingStatusRef.current },
        initialData?.status,
        pendingStatusRef.current
      ).catch((err) =>
        console.warn(
          "[BOOKING_V4_WEBSOCKET] Failed to send booking status event:",
          err
        )
      );
    },
    (error) => {
      handleError(true, error || "Failed to update status.");
      onError?.(error);
    }
  );

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    pendingStatusRef.current = newStatus;

    console.log("🔍 Status dipilih:", newStatus); // Debugging

    // ✅ Gunakan callback di setFormData agar state selalu up-to-date sebelum submit
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData, status: newStatus };

      console.log("📤 Data yang dikirim ke API:", updatedFormData); // Debugging

      // ✅ Panggil submit tanpa event (karena dropdown tidak submit form)
      handleSubmit(updatedFormData, { preventDefault: () => {} });

      return updatedFormData; // Perbarui state setelah submit
    });
  };

  return (
    <div className="form-group">
      <label htmlFor="status" className="form-label">
        Booking Status
      </label>
      <select
        className={clsx("form-select")}
        id="status"
        name="status"
        value={formData.status}
        onChange={handleStatusChange}
        disabled={isSubmitting}
      >
        {/* <option value="" disabled>Pilih status</option>
        {[
          { value: "booked", label: "Book" },
          { value: "reconfirmed", label: "Re Confirm" },
          { value: "confirmed", label: "Confirmed" },
          { value: "played", label: "Playing" },
          { value: "finished", label: "Finish" },
          { value: "cancelled", label: "Cancelled" },
        ].map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))} */}
        <option value="" disabled>
          Pilih status
        </option>
        <option value="booked">Book</option>
        <option value="reconfirmed">Re Confirm</option>
        <option value="confirmed">Confirmed</option>
        <option value="printed">Printed</option>
        <PermissionMiddleware allowedPermissions={["update-play-status"]}>
          <option value="played">Playing</option>
        </PermissionMiddleware>
        <PermissionMiddleware allowedPermissions={["update-finish-status"]}>
          <option value="finished">Finish</option>
        </PermissionMiddleware>
        <option value="cancelled">Cancelled</option>
      </select>
      {formError && <div className="text-danger mt-1">{formError}</div>}
    </div>
  );
};

export default ChangeOrderStatus;

// versi permission
// import React from 'react';
// import { useAuth } from 'hooks/useAuth'; // Mengambil data user dan permissions
// import clsx from 'clsx'; // Import clsx untuk kelas dinamis

// const BookingForm = ({ formData, handleStatusChange, isSubmitting, formError }) => {
//   const { user } = useAuth(); // Mendapatkan data user melalui hook `useAuth`

//   // Ambil semua permission user sebagai array of string
//   const userPermissions = user?.permissions?.map((permission) => permission.name) || [];

//   // Cek apakah user memiliki permission 'play' dan 'finish'
//   const canPlay = userPermissions.includes('play');
//   const canFinish = userPermissions.includes('finish');

//   return (
//     <div className="form-group">
//       <label htmlFor="status" className="form-label">Booking Status</label>
//       <select
//         className={clsx("form-select")}
//         id="status"
//         name="status"
//         value={formData.status}
//         onChange={handleStatusChange}
//         disabled={isSubmitting}
//       >
//         <option value="" disabled>Pilih status</option>

//         {/* Filter berdasarkan permission yang dimiliki user */}
//         <option value="booked">Book</option>
//         <option value="reconfirmed">Re Confirm</option>
//         <option value="confirmed">Confirmed</option>

//         {/* Tampilkan 'Playing' hanya jika user memiliki permission 'play' */}
//         {canPlay && <option value="played">Playing</option>}

//         {/* Tampilkan 'Finish' hanya jika user memiliki permission 'finish' */}
//         {canFinish && <option value="finished">Finish</option>}

//         <option value="cancelled">Cancelled</option>
//       </select>
//       {formError && <div className="text-danger mt-1">{formError}</div>}
//     </div>
//   );
// };

// export default BookingForm;
